import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { tafPCInstance, wefoxOccupationInstance } from '../Requests';
import {
  Occupation,
  OccupationServiceResponse,
} from '../../interfaces/Occupation';
import ProductType from '../../enums/ProductType';
import { isBrand } from '../../utils/utils';
import Brand from '../../enums/Brand';

export default class OccupationService {
  private readonly axiosTafInstance: AxiosInstance;

  private readonly axiosWefoxInstance: AxiosInstance;

  private readonly isWefox: boolean;

  constructor() {
    this.isWefox = isBrand(Brand.wefox);

    this.axiosTafInstance = tafPCInstance;
    this.axiosWefoxInstance = wefoxOccupationInstance;
  }

  fetchOccupations(
    language: string,
    productType: ProductType,
    policyTerms: string,
  ): Promise<Array<Occupation>> {
    console.log('occupation language', language);

    if (this.isWefox) {
      return this.fetchWefoxOccupations(productType, policyTerms);
    }
    return this.fetchTafOccupations(productType);
  }

  fetchTafOccupations(productType: ProductType): Promise<Array<Occupation>> {
    return this.axiosTafInstance
      .get(
        `/premiumcalculator/v2/occupations;/products;product-type=${productType}`,
      )
      .then((response: AxiosResponse<OccupationServiceResponse>) => {
        return response.data.results.filter(
          (occupation: Occupation) => !occupation.excluded,
        ).sort((a: Occupation, b: Occupation) => a.occupation.name.localeCompare(b.occupation.name));
      })
      .catch((error: AxiosError) => {
        throw Error(error.message);
      })
      .finally(() => {
        return [];
      });
  }

  fetchWefoxOccupations(
    productType: ProductType,
    policyTerm: string,
  ): Promise<Array<Occupation>> {
    return this.axiosWefoxInstance
      .get(
        `/v3/occupations/products;product-type=${productType};policy-terms=${policyTerm}`,
      )
      .then((response: AxiosResponse<Array<Occupation>>) => response.data)
      .catch((error: AxiosError) => {
        throw Error(error.message);
      })
      .finally(() => {
        return [];
      });
  }
}
